import React from 'react';
import {ClassListTitle, ContainerBox, AlertFull} from '../Style/ClassList.style';
import ClassListWithImages from './ClassListWithImages.view';
import ClassListEmpty from './ClassListEmpty.view';
import {IPropsClassList} from '../Config/ClassList.types';
import {BackendTagField} from '../../../configuration/backendFileds/backendFileld.config';
import useClassList from '../Controller/useClassList.controller';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';

const ClassList = ({autoProjectState, setState, onDoneProcess, getChosenFiles, uiFileList, numberOfUploadFiles, uploadCounter, onDeleteFile, uiFiledFileList, retryAllFiledFiles, deleteClass}:IPropsClassList) => {
    const {activeEditId, activeEditClass} = useClassList(setState, autoProjectState, uploadCounter);

    return (
        <ContainerBox id='create-auto-project-class-list'>
            <ClassListTitle>{_SYSTEM_TITLES.createAutoProjectClasslistTitle}</ClassListTitle>
            {autoProjectState.classMainError && <AlertFull severity='error' >{autoProjectState.classMainError}</AlertFull>}
            {autoProjectState.classes.length > 0
                ? autoProjectState.classes.map((c, index) => <ClassListWithImages
                    retryAllFiledFiles={retryAllFiledFiles}
                    deleteClass={deleteClass}
                    uiFiledFileList={uiFiledFileList}
                    getChosenFiles={getChosenFiles}
                    onDoneProcess={onDoneProcess}
                    activeEditClass={activeEditClass}
                    setState={setState}
                    onDeleteFile={onDeleteFile}
                    class_id={index}
                    activeEditId={activeEditId}
                    autoProjectState={autoProjectState}
                    key={index}
                    className={c[BackendTagField.name]}
                    numberOfSuccess={activeEditId === index ? uploadCounter : c.imageList.length}
                    numberOfFiles={autoProjectState.minReference}
                    numberOfUploadFiles={numberOfUploadFiles}
                    itemData={activeEditId === index ? uiFileList : c.imageList}/>)
                : <ClassListEmpty inputerror={autoProjectState.classMainError}/>
            }
        </ContainerBox>
    );
};

export default ClassList;
